import { PageRoute } from 'src/routes/routes-behind-login/page-route'
import {
  FileIcon,
  LifebuoyIcon,
  PhoneIcon,
  SettingsIcon,
  UserIcon,
} from '~components/icons'
import {
  ExactScopeName,
  useHasEntityRole,
  useHasScope,
} from '~hooks/permissions/use-has-scope'
import { useConstructLinkWithPool } from '~hooks/use-construct-link-with-pool'
import { NavItem } from '../components/menu-items-renderer'
import { useShowLimitedExperience } from './use-show-limited-experience'

export function useSubheaderLinks() {
  const documentsLink = useConstructLinkWithPool('/documents/:pool')
  const isMtUser = useHasScope(ExactScopeName.maerskTankersUser)
  const isDppLimited = useShowLimitedExperience()
  const isPoolPartnerUser = useHasEntityRole('poolpartner', 'user')
  const canManageUsers = useHasScope(
    ExactScopeName.mtopsVessel,
    '*:*:accountmanager',
    '*:*:admin',
  )

  const isStreamsReader = useHasScope('*:*:admin', 'system:errorstream:read')

  const isNotificationWriter = useHasScope(
    ExactScopeName.notificationWriter,
    'settings:*:write',
  )

  const isWelcomePopupWriter = useHasScope(
    ExactScopeName.welcomePopupWriter,
    'settings:*:write',
  )

  const canEditContacts = useHasScope(
    'settings:contacts:write',
    'settings:*:write',
  )

  const isVesselTechnical = useHasEntityRole('vessel', 'technical')

  const subheaderPages: NavItem[] = []

  if (canManageUsers) {
    subheaderPages.push({
      title: 'account manager',
      link: PageRoute.ACCOUNT_MANAGER,
      icon: <UserIcon />,
      children: [
        {
          title: 'Users',
          link: `/${PageRoute.USERS}`,
        },
        {
          title: 'Pool Partners',
          link: `/${PageRoute.POOL_PARTNERS}`,
        },
      ],
    })
  }

  if (isNotificationWriter || isWelcomePopupWriter || isStreamsReader) {
    subheaderPages.push({
      title: 'System settings',
      link: PageRoute.SYSTEM_SETTINGS,
      icon: <SettingsIcon />,
      children: [
        ...(!isStreamsReader
          ? []
          : [
              {
                title: 'Error Stream',
                link: `/${PageRoute.ERROR_STREAM}`,
              },
            ]),
        ...(!isWelcomePopupWriter
          ? []
          : [
              {
                title: 'Welcome Popup',
                link: `/${PageRoute.WELCOME_POPUP}`,
              },
            ]),
        ...(!isNotificationWriter
          ? []
          : [
              {
                title: 'Notification Banners',
                link: `/${PageRoute.NOTIFICATION_BANNER}`,
              },
            ]),
      ],
    })
  }

  if (!isDppLimited && (isMtUser || isPoolPartnerUser)) {
    subheaderPages.push({
      title: 'documents',
      link: documentsLink,
      icon: <FileIcon />,
      className: 'tour-step-nav-documents',
    })
  }

  if (!isDppLimited && (isMtUser || isPoolPartnerUser || isVesselTechnical)) {
    subheaderPages.push({
      title: 'help',
      link: '/help',
      icon: <LifebuoyIcon />,
      className: 'tour-step-nav-help',
    })
  }

  if (canEditContacts || isPoolPartnerUser || isVesselTechnical) {
    subheaderPages.push({
      title: 'contact',
      link: '/contact',
      icon: <PhoneIcon />,
    })
  }

  return subheaderPages
}
